import { styled } from '@mui/material/styles';

export const RadarXYAxesLine = styled('line')(({ theme }) => ({
  strokeWidth: 2,
  // opacity: 0.2,
  stroke: theme.palette.primary.light,
}));
